import { render, staticRenderFns } from "./122.vue?vue&type=template&id=2f39ce8c&scoped=true&"
var script = {}
import style0 from "./122.vue?vue&type=style&index=0&id=2f39ce8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39ce8c",
  null
  
)

export default component.exports